import Application from "./ApplicationContainer";
import Verifications from "./Verifications";

export default Application;
export { Verifications };
